import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import useFetchCart from './FetchCart';
import BASE_URL, { getImageURL } from '../config';

const stripePromise = loadStripe('your-publishable-key-here');


const CheckoutForms = () => {


    const [shippingAddress, setShippingAddress] = useState({
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        postal_code: '',
        country: 'Switzerland',
        phone: '',
      });



  const { cart, loading, error, fetchCart } = useFetchCart();
  const [billingAddress, setBillingAddress] = useState('');
  const [couponCode, setCouponCode] = useState('');
  const [deliveryType, setDeliveryType] = useState('pickup');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  console.log(cart)

  const checkoutdatass = JSON.parse(localStorage.getItem('checkoutdata'));




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setShippingAddress({ ...shippingAddress, [name]: value });
  };

  const shippingCost = deliveryType === 'pickup' ? 0 : 20;
  
  // Calculate total price
  const total = cart && cart.items ? cart.total_price + shippingCost : 0;

  const handleSubmit = (event) => {
    event.preventDefault();

    const orderData = {
      items: cart.items.map(item => ({
        item_id: item.item.title,
        item_image: item.item.mainimage,
        quantity: item.item.quantity,
      })),
      delivery_type: deliveryType,
      delivery_date: checkoutdatass.selectedDate,
      delivery_time: checkoutdatass.selectedTime,
      billing_address: shippingAddress,
      shipping_address: shippingAddress,
      coupon_code: couponCode,
      total: total,
    };

    localStorage.setItem('orderData', JSON.stringify(orderData));
    navigate('/review-order');
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let i = 9; i <= 17; i++) {
      options.push(`${i}:00`);
    }
    return options;
  };

  const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6; // Disable weekends
  };

  const minDate = new Date();
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30); 

  return (
    <div className="container mt-5">
      <h2>Checkout</h2>
      <form onSubmit={handleSubmit}>
        <div className='row mb-5'>
          <div className='col-md-6 contact'>
            <div className='row mb-5'>
              <div className='col-md-12'>
              <div className='form-floating'>
                  <input type='text' className='form-control' id="phone" name='phone' placeholder='Email or Phone Number'>
                  </input>
                  <label htmlFor="phone">Email or Mobile Phone Number</label>
                </div>
                </div>
                </div>

            <div className='row mb-5'>
              <h2>Delivery</h2>

                          <div className='col-md-12'>
                          <div className='form-floating mb-3'>
                          <select 
          className='form-select' 
          id='country' 
          name='country' 
          value={shippingAddress.country} 
          onChange={handleInputChange}
        >
          <option value="Switzerland">Switzerland</option>
          <option value="Germany">Germany</option>
        </select>
              <label htmlFor="country">Country</label>
            </div>

                </div>



                <div className='col-md-6'>
                <div className='form-floating mb-3'>
                <input type='text' className='form-control' id="firstname" name='firstname' placeholder='First Name'>
                  </input>
                  <label htmlFor="firstname">First Name</label>

                </div>
              </div>

              <div className='col-md-6'>
              <div className='form-floating mb-3'>
              <input type='text' className='form-control' id="lastname" name='lastname' placeholder='Last Name' required />
                  <label htmlFor="lastname">Last Name</label>

                </div>
                </div>

                <div className='col-md-12'>
              <div className='form-floating mb-3'>
              <input 
          type='text' 
          className='form-control' 
          id="address" 
          name='address_line1' 
          placeholder='Address' 
          required 
          onChange={handleInputChange}
          value={shippingAddress.address_line1}
        />                  <label htmlFor="address">Address</label>
                </div>
                <div className='form-floating mb-3'>
                <input 
          type='text' 
          className='form-control' 
          id="apartment" 
          name='address_line2' 
          placeholder='Apartment, suite, etc, (Optional)' 
          onChange={handleInputChange}
          value={shippingAddress.address_line2}
        />                  <label htmlFor="apartment">Apartment, suite, etc, (Opional)</label>
                </div>

                </div>

                <div className='col-md-6'>
              <div className='form-floating mb-3'>
              <input 
          type='text' 
          className='form-control' 
          id="postal" 
          name='postal_code' 
          placeholder='Postal Code' 
          required 
          onChange={handleInputChange}
          value={shippingAddress.postal_code}
        />
        <label htmlFor="postal">Postal Code</label>

                </div>
                </div>

                <div className='col-md-6'>
              <div className='form-floating mb-3'>
              <input 
          type='text' 
          className='form-control' 
          id="city" 
          name='city' 
          placeholder='City' 
          required 
          onChange={handleInputChange}
          value={shippingAddress.city}
        />                  <label htmlFor="city">City</label>

                </div>
                </div>
                <div className='col-md-12'>
              <div className='form-floating mb-3'>
              <input 
          type='text' 
          className='form-control' 
          id="phone" 
          name='phone' 
          placeholder='Email or Phone Number' 
          onChange={handleInputChange}
          value={shippingAddress.phone}
        />                  <label htmlFor="phonenumber">Phone</label>
                </div>
                </div>

            </div>
          </div>
          <div className='col-md-6'>
  <h4>Your Cart</h4>
  <ul>
    {cart && cart.items ? (
      cart.items.map((item) => (
        <li key={item.id}> {/* Add a unique key for each item */}
          <img src={item.item.mainimage? getImageURL(item.item.mainimage) : 'placeholder.jpg' } style={{ width: '50px', height: '50px', marginRight: '10px' }} alt={item.item.title} />
          <span>{item.item.title}</span> - <strong>{((parseFloat(item.item.discount_price) || parseFloat(item.item.price) || 0) * item.quantity).toFixed(2)} CHF</strong>
        </li>
      ))
    ) : (
      <li>Your cart is empty.</li> // Fallback message if cart is null or empty
    )}
  </ul>

  {/* Subtotal */}
  <div className="d-flex justify-content-between">
    <span>Subtotal:</span>
    <strong>{cart ? `${cart.total_price} CHF` : '0.00 CHF'}</strong>
  </div>

  {/* Shipping */}
  <div className="d-flex justify-content-between">
    <span>Shipping:</span>
    <strong>{shippingCost.toFixed(2)} CHF</strong>
    </div>

  {/* Total */}
  <div className="d-flex justify-content-between">
    <span>Total:</span>
    <strong>{total.toFixed(2)} CHF</strong>
    </div>
</div>


        </div>
        {/* Billing Address */}


      
        {/* Coupon Code */}
        <div className="mb-3">
          <label htmlFor="couponCode" className="form-label">Coupon Code</label>
          <input
            type="text"
            id="couponCode"
            className="form-control"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
          />
          {errors.coupon_code && <p className="text-danger">{errors.coupon_code}</p>}
        </div>

        {/* Delivery Options */}
        <div className="mb-3">
          <h5>Delivery Options</h5>
      
          <div className="form-check">
          <input
        type="radio"
        id="homeDelivery"
        name="deliveryType"
        value="delivery"
        checked={deliveryType === "delivery"}
        onChange={() => setDeliveryType("delivery")}
        className="form-check-input"
      />
      <label htmlFor="homeDelivery" className="form-check-label">
        Home Delivery
      </label>
    </div>
        </div>

        {/* Date & Time Selection */}
        {deliveryType === 'homeDelivery' && (
          <>
            <div className="mb-3">
              <label htmlFor="deliveryDate" className="form-label">Choose Delivery Date</label>
              <div className="form-control" onClick={() => setCalendarVisible(!calendarVisible)}>
                {selectedDate ? moment(selectedDate).format('ddd, D MMMM YYYY') : 'Select a date'}
              </div>
              {calendarVisible && (
                <Calendar
                  onChange={setSelectedDate}
                  value={selectedDate}
                  minDate={minDate}
                  maxDate={maxDate}
                  tileDisabled={({ date }) => isWeekend(date)}
                />
              )}
              {errors.delivery_date && <p className="text-danger">{errors.delivery_date}</p>}
            </div>

            {selectedDate && (
              <div className="mb-3">
                <label htmlFor="deliveryTime" className="form-label">Choose Delivery Time</label>
                <select
                  id="deliveryTime"
                  className="form-control"
                  value={selectedTime}
                  onChange={(e) => setSelectedTime(e.target.value)}
                  required
                >
                  <option value="">Select a time</option>
                  {generateTimeOptions().map(time => (
                    <option key={time} value={time}>{time}</option>
                  ))}
                </select>
                {errors.delivery_time && <p className="text-danger">{errors.delivery_time}</p>}
              </div>
            )}
          </>
        )}

      

<button type="submit" className="cta">Review Order</button>
</form>
    </div>
  );
};

const CheckoutForm = () => {
    return (
        <CheckoutForms />
    );
  };
  
  export default CheckoutForm;
